import { xcss, Box } from '@atlaskit/primitives';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useToken } from '../../../../Flow/ConsentContextProvider';

const centeredContentStyles = xcss({
  textAlign: 'center',
});

const messages = defineMessages({
  title: {
    id: 'heading.partnercentral',
    defaultMessage: '{clientName} is requesting access to your Partner Central account',
    description: 'Heading for Partner Central Consent',
  },
});

const Header = () => {
  const { clientName } = useToken();

  return (
    <Box xcss={centeredContentStyles}>
      <FormattedMessage {...messages.title} values={{ clientName }} tagName="h1" />
    </Box>
  );
};

export default Header;
